<app-header *ngIf="!(location == '/coming-soon')"></app-header>
<router-outlet></router-outlet>
<app-footer *ngIf="!(location == '/coming-soon')"></app-footer>
